function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M226.8 113.3l56.7-70.8H250L262.2 0l-56.7 70.8h33.4l-12.1 42.5zM230.2 127.3h-53.1v92.2h-90l76.1-15.4-17-84 28.7-5.6-5.5-28L0 120.4l21 104.2V248h35.1v.3c0 20.9 14.2 35.2 35.9 35.2 20.8 0 34.9-14.1 35.2-35.4h70.4v.3c0 20.9 14.2 35.2 35.9 35.2 20.8 0 34.9-14.1 35.2-35.4h14.8v-64.9l-53.3-56zM44.4 199.7l-11.6-57.6 86.1-17.4 11.6 57.6-86.1 17.4zm210.5 19.8h-49.3v-63.6H218l36.9 38.7v24.9z"
})));